import {
  FileHandlerCreator,
  FileKey,
  createFileHandler,
} from './FileHandlerConfig';

/**
 * No-op file handler that immediately succeeds without uploading.
 * Used for free users to mock a file upload in the UI without making API calls.
 */
export const createNoOpHandler: FileHandlerCreator<FileKey> = createFileHandler(
  ({
    onSuccess,
  }: {
    onSuccess?: (data: FileKey) => void;
    onError?: (error: unknown) => void;
  } = {}) => {
    return async ({ file }) => {
      const mockFileKey = `mock-file-key-${Date.now()}`;
      onSuccess?.({ type: 'fileKey' as const, fileKey: mockFileKey, file });
      return { type: 'fileKey' as const, fileKey: mockFileKey, file };
    };
  }
);
